export const languages = ['en', 'lt']
